import * as React from 'react'
import { useNavigate } from 'react-router-dom'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import { toast } from 'react-toastify'
import { useAuth } from '../../Context/AuthContext'
import CustomLoader from '../../Component/CustomLoader/customLoader'

const MicrosoftCallback = () => {
  const navigate = useNavigate()
  const { handleMicrosoftCallback } = useAuth()
  const [error, setError] = React.useState('')

  React.useEffect(() => {
    handleCallback()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const finalizeLogin = (accessToken, refreshToken) => {
    try {
      handleMicrosoftCallback(accessToken, refreshToken || '')
      // Clean tokens from URL before navigating
      window.history.replaceState({}, document.title, '/auth/callback')
      toast.success('Signed in with Microsoft.')
      navigate('/home')
    } catch (err) {
      setError(err.message || 'Microsoft sign-in failed.')
    }
  }

  const handleCallback = () => {
    // Service worker may intercept the OAuth callback URL and store tokens in sessionStorage
    const swAccessToken = sessionStorage.getItem('viz_sso_access_token')
    if (swAccessToken) {
      const swRefreshToken = sessionStorage.getItem('viz_sso_refresh_token') || ''
      sessionStorage.removeItem('viz_sso_access_token')
      sessionStorage.removeItem('viz_sso_refresh_token')
      sessionStorage.removeItem('viz_sso_expiration')
      sessionStorage.removeItem('viz_sso_is_new_user')
      finalizeLogin(swAccessToken, swRefreshToken)
      return
    }

    const params = new URLSearchParams(window.location.search)
    const accessToken = params.get('access_token')
    const refreshToken = params.get('refresh_token')
    const providerError = params.get('error')

    if (providerError) {
      setError(decodeURIComponent(providerError))
      return
    }

    if (accessToken) {
      finalizeLogin(accessToken, refreshToken || '')
      return
    }

    setError('No authentication data received from Microsoft. Please try again.')
  }

  if (error) {
    return (
      <Box
        sx={{
          height: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: '#000',
          gap: 2,
          p: 3,
        }}
      >
        <Typography color="error" variant="h6" textAlign="center">
          Microsoft Sign-In Failed
        </Typography>
        <Typography color="text.secondary" textAlign="center" variant="body2">
          {error}
        </Typography>
        <Button variant="contained" onClick={() => navigate('/')}>
          Back to Sign In
        </Button>
      </Box>
    )
  }

  return (
    <Box
      sx={{
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: '#000',
        gap: 2,
      }}
    >
      <CustomLoader />
      <Typography color="white" variant="body2">
        Completing Microsoft sign-in…
      </Typography>
    </Box>
  )
}

export default MicrosoftCallback
